module.exports = __webpack_public_path__ + "static/budgetarian-7df155ae8ea0e125af9c3d935928d24b.png";